module.exports = __webpack_public_path__ + "img/icon-7.4ac206f7.png";